<template>
  <div style="margin-top: -20px">
    <div class="mb-3 mt-0">
      <div class="mb-2">Tiêu đề</div>
      <el-input placeholder="Nhập tiêu đề để dễ nhớ hơn." v-model="title"></el-input>
    </div>
    <div class="mb-3">
      <div class="mb-2">Nội dung <span class="zalo-text-danger">*</span></div>
      <el-input
        type="textarea"
        :autosize="{ minRows: 3, maxRows: 6}"
        placeholder="Nhập nội dung công việc"
        v-model="content">
      </el-input>
    </div>
    <div class="mb-3">
      <div class="mb-2">Giao cho <span class="zalo-text-danger">*</span></div>
      <div class="d-flex">
        <el-select class="w-100 me-2 " filterable :disabled="isLoadingButton"
                   v-model="listAssgineeValue"
                   multiple
                   collapse-tags
                   placeholder="Chọn người được giao">
          <el-option
            v-for="item in listOptions"
            :key="item.uid"
            :label="item.displayName"
            :value="item.uid">
            <div class="d-flex align-items-center">
              <el-avatar :size="24" :src="item.avatar" />
              <div class="ms-2">{{ item.displayName }}</div>
            </div>
          </el-option>
        </el-select>

      </div>
      <div>

      </div>
    </div>
    <div class="mb-3 d-flex flex-column">
      <div class="mb-2 ">Thời hạn</div>
      <el-date-picker class="w-100"
                      v-model="dueDate"
                      type="datetime"
                      placeholder="Không thời hạn"
                      default-time="12:00:00"
      >
      </el-date-picker>
      <!--      <div class="mb-3" />-->
    </div>
    <!--                 :disabled="listAssgineeValue.length===1 && listAssgineeValue[0]===accountSelected.accountId || listAssgineeValue.length===0"-->

    <div v-if="isShowAssginessWhere()" class="">
      <div class="mb-2">Giao tại <span class="zalo-text-danger">*</span></div>
      <el-select class="w-100 " :loading="loadingFromWeebhook" loading-text="Đang tìm kiếm..."
                 @focus="getCommonGroupV2()"
                 filterable v-model="destination" placeholder="Chọn hội thoại" value="">
        <el-option
          v-for="item in listIdGroups"
          :key="item.accountMemberId"
          :label="item.name"
          :value="item.accountMemberId">
          <div class="d-flex align-items-center">
            <img style="max-width: 20px;max-height: 20px;border-radius: 999px" class="ms-2 flex-1" :src="getAvatar(item.avatar)" />
            <div class="ms-2">{{ item.name }}</div>
          </div>
        </el-option>
      </el-select>
    </div>
    <div class="mt-3 d-flex justify-content-end">
      <el-button type="danger" @click="closeDialog()">Hủy</el-button>
      <el-button :loading="isLoading"  @click="createTodo()" type="primary">Giao việc</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "CreateTodo",
  props: {
    accountSelected: {
      type: Object
    }
  },
  data() {
    return {
      isLoadingButton: false,
      showDesti: false,
      isLoading: false,
      title: "",
      content: "",
      listAssgineeValue: [],
      dueDate: "",
      destination: "",
      listIdGroups: [],
      loadingFromWeebhook: false
    };
  },
  watch: {
    listAssgineeValue: function() {
      this.showDesti = false;
      this.listIdGroups = [];
      this.destination = "";
    }
  },
  computed: {
    isDisabled() {
      return false;
      // let isDueDateMatch;
      // if (this.dueDate === -1 || this.dueDate == "" || this.dueDate == null) {
      //   isDueDateMatch = false;
      // } else isDueDateMatch = new Date(this.dueDate).getTime() <= new Date().getTime();
      // // let showDesti ;
      // //neu nhieu nguoi thi show giao tai ra, chua show thi phai disable
      // return this.listAssgineeValue.length === 0 || (this.listAssgineeValue.length === 1 && this.accountSelected.accountId === this.listAssgineeValue[0]) || isDueDateMatch || this.content.trim().length === 0;

    },
    listOptions() {
      let item = JSON.parse(JSON.stringify(this.app.listContactsAccount));
      item.unshift({
        uid: this.accountSelected.accountId,
        displayName: this.accountSelected.displayName,
        avatar: this.accountSelected.avatar
      });
      return item;
    }
  },
  methods: {
    getAvatar(src) {
      if (src && src.length === 0 || !src) {
        return "/assets/images/no-avatar.png";
      }
      return src;
    },
    isShowAssginessWhere() {
      if (this.listAssgineeValue.length > 1) {
        return true;
      } else {
        return false;
      }

    },
    isGroup() {
      return this.destination.includes("g");
    },
    getCommonGroupV2() {
      if (this.listIdGroups.length > 0) return;
      if (this.listAssgineeValue.length === 0) return;
      if (this.loadingFromWeebhook) return;
      this.loadingFromWeebhook = true;
      let req = this.listAssgineeValue;

      this.$http.post("/api/conversation/getCommonGroup?accountId=" + this.accountSelected.accountId, req);

    },
    getCommonGroup() {
      this.isLoadingButton = true;

      let req = this.listAssgineeValue;
      if (!req.includes(this.accountSelected.accountId)) {
        req.push(this.accountSelected.accountId);
      }
      this.$http.post("/api/conversation/getCommonGroup?accountId=" + this.accountSelected.accountId, req);
    },
    isShowDestination() {
      return this.listAssgineeValue.length > 1 && (!this.listAssgineeValue.includes(this.accountSelected.accountId) || this.listAssgineeValue.length > 2);
    },
    getDateDefaultType() {
      if (this.dueDate === null || this.dueDate === -1 || this.dueDate === "") {
        return 0;
      } else {
        return 5;
      }
    },
    getDueDate() {
      if (this.dueDate === null || this.dueDate === -1 || this.dueDate === "") {
        return -1;
      } else {
        return new Date(this.dueDate).getTime();
      }
    },
    sendMessage(toId) {
      let req = {
        message: this.content.trim(),
        accountId: this.accountSelected.accountId,
        toId: toId
      };
      return this.$http.post("/api/message/sms", req).then(s => {
        return s.data;
      });
    },
    sendGroupMessage(toId) {
      let request = {
        accountId: this.accountSelected.accountId,
        groupId: toId,
        message: this.content.trim()
      };
      return this.$http.post("/api/message/groupMsg", request).then(s => {
        return s.data;
      });
    },

    async createTodo() {
      if (this.loadingFromWeebhook === true) return this.alertError("Vui lòng chờ");
      if (this.getDueDate() !== -1) {
        let isDueDateMatch = new Date(this.dueDate).getTime() <= new Date().getTime();
        if (isDueDateMatch)
          return this.alertError("Ngày giờ không chính xác.");
      }

      if (this.content.trim().length === 0) return this.alertError("Vui lòng nhập nội dung");
      if (this.listAssgineeValue.length === 0) {
        return this.alertError("Chưa chọn người được giao");
      }

      if (this.listAssgineeValue.length === 1 && this.listAssgineeValue[0] === this.accountSelected.accountId) {
        return this.alertError("Chưa hỗ trợ giao việc cho bản thân");
      }

      let toId;

      if (!(this.isAssgineesIndividual() || this.listAssgineeValue.length === 1)) {
        if (this.destination.length === 0) {
          return this.alertError("Chưa chọn hội thoại");
        }
      }
      if (!this.isGroup()) {
        if (this.isAssgineesIndividual() && this.destination.length === 0) {
          return this.alertError("Chưa chọn hội thoại");
        }
        toId = this.listAssgineeValue.find(s => s !== this.accountSelected.accountId);
      } else {
        if (this.destination.length === 0) return this.alertError("\"Chưa chọn hội thoại");
        toId = this.destination.split("_")[1].slice(0, -1);

        if (toId == "1") {
          this.isLoading = true;
          let data = await this.createGroup();
          if (data?.data?.groupId) {
            toId = data.data.groupId;
          } else {
            return;
          }
        }
      }
      this.isLoading = true;



      let dataMessage;
      if (this.isGroup()) {
        dataMessage = await this.sendGroupMessage(toId);
      } else {
        dataMessage = await this.sendMessage(toId);
      }


      if (dataMessage.error_code !== 0) {
        return this.alertError(dataMessage.error_message);
      }
      let extra = {
        msgId: dataMessage.data.msgId,
        toUid: toId,
        isGroup: this.isGroup(),
        cliMsgId: new Date().getTime(),
        msgType: 1,
        mention: [],
        ownerMsgUId: this.accountSelected.accountId,
        message: this.content
      };

      let req = {
        accountId: this.accountSelected.accountId,
        assignees: this.listAssgineeValue,
        content: this.content,
        dateDefaultType: this.getDateDefaultType(),
        description: this.title,
        dueDate: this.getDueDate(),
        extra: JSON.stringify(extra)
      };

      this.$http.post("/api/todo/createTodo", req).then((resp) => {
        if (resp.data.error_code === 0) {
          this.alert("success", "Giao việc thành công");
          this.closeDialog();
          this.$emit("loadTodoList");
        } else {
          return this.alertError("Lỗi xảy ra, xin thử lại");
        }

      }).catch(() => {
        this.alertError("Lỗi xảy ra, xin thử lại");
      }).finally(() => {
        this.isLoading = false;
      });
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
    getNameGroup() {
      let result;
      let arrNames = [];
      this.listAssgineeValue.forEach(s => {
        arrNames.push(this.listOptions.find(l => l.uid === s).displayName);
      });
      if (this.listAssgineeValue.length > 3) {
        result = arrNames.slice(0, 3).join(",").toString() + "...";
      } else {
        result = arrNames.join(",");
      }
      return result.slice(0, 20).toString() + "...";
    },
    isAssgineesIndividual() {
      if (this.listAssgineeValue.length === 2) {
        if (this.listAssgineeValue.includes(this.accountSelected.accountId)) {
          return true;
        }
      }

      return false;
    },
    createGroup() {
      let body = {
        groupName: this.getNameGroup(),
        accountId: this.accountSelected.accountId,
        membersId: this.listAssgineeValue
      };
      return this.$http.post("/api/conversation/createGroup", body).then((resp) => {
        if (resp.data.error_code === 270) {
          return this.alert("error", "Bạn đã đạt giới hạn tạo nhóm trong ngày.");
        }
        if (resp.data.error_code !== 0) {
          return this.alert("error", resp.data.error_message);

        }
        return resp.data;
      });
    }
  },
  mounted() {
    this.$bus.$on("eventGetCommonGroup", body => {
      this.isLoadingButton = false;
      this.showDesti = true;
      let data = body.data;
      let items = body.id;
      let arr = [];
      items.forEach(s => {
        let item = s.split("_");
        arr.push(item[1]);
      });
      if (arr.some(r => this.listAssgineeValue.includes(r)) && this.accountSelected.accountId === body.accountId) {
        data.forEach(s => s.accountMemberId = s.accountMemberId + "g");
        this.listIdGroups = data;
        if (this.isAssgineesIndividual()) {
          let item = this.listAssgineeValue.find(s => s !== this.accountSelected.accountId);
          let itemSelected = this.listOptions.find(s => s.uid === item);
          this.listIdGroups.unshift({
            accountMemberId: this.accountSelected.accountId + "_" + item,
            name: itemSelected.displayName,
            avatar: itemSelected.avatar
          });
        } else {
          this.listIdGroups.unshift({
            accountMemberId: this.accountSelected.accountId + "_" + "1g",
            name: "TẠO NHÓM MỚI",
            avatar: "/assets/icon/add_group.svg"
          });
        }

        this.loadingFromWeebhook = false;
      }


    });
  },
  beforeDestroy() {
    this.$bus.$off("eventGetCommonGroup");
  }
};
</script>

<style scoped>

</style>